<div class="branch-definitions">
    @for (brancheDefinition of libraryBranchDefinitions; track $index; let i = $index) {
        <div class="branch-definition">
            <mat-form-field floatLabel="always">
                <mat-label>Owner</mat-label>
                <input
                    matInput
                    [ngModel]="brancheDefinition.owner"
                    (ngModelChange)="updateOwner($event, brancheDefinition)"
                    [matAutocomplete]="auto"
                />
                <mat-autocomplete #auto="matAutocomplete">
                    @for (library of filterLibraries(brancheDefinition.owner); track library.owner) {
                        <mat-option [value]="library.owner">{{library.owner}}</mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
            @if (libraryByOwners.has(brancheDefinition.owner)) {
                @let availableBranches = libraryByOwners.get(brancheDefinition.owner)!.branches;
                <mat-form-field floatLabel="always">
                    <mat-label>Branch</mat-label>
                    <mat-select [(ngModel)]="brancheDefinition.branch" (valueChange)="updateLibraryBranches()" (selectionChange)="updateLibraryBranches()">
                        @for (availableBranch of availableBranches; track availableBranch.name) {
                            <mat-option [value]="availableBranch.name">{{ availableBranch.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            } @else {
                <mat-form-field floatLabel="always">
                    <mat-label>Branch</mat-label>
                    <input
                        matInput
                        [(ngModel)]="brancheDefinition.branch"
                        (change)="updateLibraryBranches()"
                    />
                </mat-form-field>
            }
            <button mat-icon-button (click)="removeBranchDefinition(i)">
                <mat-icon>delete</mat-icon>
            </button>
        </div>
    }
</div>
<button mat-stroked-button (click)="addBranchDefinition()" [disabled]="!canAddBranches()">
    <mat-icon>add</mat-icon>
    Configure library branches
</button>
